import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public user: any = {};
    public communities: any[] = [];
    public activeCommunityId: string = "";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public async load() {
        this.activeCommunityId = new URLSearchParams(location.search).get("community_id") || "";
        const { code, data } = await wiz.call("sidebar");
        if (code === 200) {
            this.user = data.user || {};
            this.communities = data.communities || [];
            if (!this.activeCommunityId) this.activeCommunityId = this.communities[0]?.id || "";
        }
        await this.service.render();
    }

    public communityHref(community: any) {
        return `/dashboard?community_id=${encodeURIComponent(community.id)}`;
    }

    public communityClass(community: any) {
        const active = this.isActive("/dashboard") && community.id === this.activeCommunityId;
        if (active) {
            return "flex h-11 w-11 items-center justify-center rounded-2xl text-sm font-black text-white shadow-lg shadow-slate-200 ring-2 ring-slate-950";
        }
        return "flex h-11 w-11 items-center justify-center rounded-2xl text-sm font-black text-white shadow-sm transition hover:scale-105 hover:ring-2 hover:ring-slate-200";
    }

    public openCreateCommunity(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.service.status.toggle('navbar', true);

        if (this.isActive("/dashboard")) {
            window.dispatchEvent(new CustomEvent("season-open-community-modal"));
            return;
        }

        location.href = "/dashboard?newCommunity=1";
    }
}

export default ComponentNavSidebarComponent;